import Papa from "papaparse";

export const CSV_UTF8_BOM = "\uFEFF";
export const CSV_TINY_NUMBER_THRESHOLD = 0.000001;

const SCIENTIFIC_NUMBER_TOKEN_PATTERN = /(^|[\s,"])(?:')?(-?(?:\d+(?:\.\d*)?|\.\d+)[eE][+-]?\d+)(?=([\s,"]|$))/g;

function isTinyNumber(value) {
    return Number.isFinite(value) && Math.abs(value) < CSV_TINY_NUMBER_THRESHOLD;
}

function normalizeNumber(value) {
    if (!Number.isFinite(value)) return "";
    if (isTinyNumber(value)) return 0;
    return value;
}

export function sanitizeCsvValue(value) {
    if (typeof value === "number") {
        return normalizeNumber(value);
    }

    if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return value;
        const unprefixed = trimmed.startsWith("'") ? trimmed.slice(1) : trimmed;
        const numericValue = Number(unprefixed);
        if (Number.isFinite(numericValue) && isTinyNumber(numericValue)) {
            return "0";
        }
    }

    return value;
}

export function sanitizeCsvRows(rows) {
    if (Array.isArray(rows)) {
        return rows.map((row) => sanitizeCsvRows(row));
    }

    if (rows && typeof rows === "object") {
        return Object.entries(rows).reduce((accumulator, [key, value]) => ({
            ...accumulator,
            [key]: sanitizeCsvValue(value),
        }), {});
    }

    return sanitizeCsvValue(rows);
}

export function sanitizeCsvContent(csvContent) {
    return String(csvContent || "").replace(
        SCIENTIFIC_NUMBER_TOKEN_PATTERN,
        (match, prefix, numericToken) => {
            const numericValue = Number(numericToken);
            return isTinyNumber(numericValue) ? `${prefix}0` : match;
        }
    );
}

export function unparseSanitizedCsv(data, options) {
    return Papa.unparse(sanitizeCsvRows(data), options);
}

export function downloadCsvContent(csvContent, filename) {
    const sanitizedContent = sanitizeCsvContent(csvContent);
    const blob = new Blob([CSV_UTF8_BOM, sanitizedContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
